import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { UiAlert, UiButton, UiIcon } from 'ui-components';
import PropTypes from 'prop-types';
import { isUndefined } from 'lib';
import {
  StyledFiltersWrapper,
  StyledResetButton,
  StyledUiDialog,
} from './addFilter.styles';
import FilterList from './FilterList';
import { StyledActions, StyledMain } from './addFilterDialog.styles';

function AddFilterDialog({
  onReset,
  onApply,
  onClose,
  mapToComponent,
  sliceModule,
  allowedFilters,
}) {
  const { platform } = useParams();
  const { t, i18n } = useTranslation();

  const selectedFilter = useSelector(
    (state) => state[state.filterReducer.filtersContext]?.selectedFilter
  );
  const isOpenSidebarFilters = useSelector(
    (state) => state.filterReducer.isOpenSidebarFilters
  );

  const Component = mapToComponent[selectedFilter];

  return (
    <StyledUiDialog open={isOpenSidebarFilters} onClose={onClose}>
      <StyledMain>
        <StyledFiltersWrapper hoverOnlyScrollbar>
          <div className='header'>
            <UiIcon icon='icon ri-equalizer-line' size={20} />
            {t('filter:filterSettings')}
            {platform ? t(`common:${platform}`) : ''}
          </div>
          <div className='body'>
            <FilterList
              mapToComponent={mapToComponent}
              sliceModule={sliceModule}
              allowedFilters={allowedFilters}
            />
          </div>
        </StyledFiltersWrapper>
        <div className='selected-filter-wrapper'>
          <UiAlert severity='info' className='mb-32'>
            {t(`filter:${selectedFilter}Description`)}
          </UiAlert>
          {i18n.exists(`filter:${selectedFilter}Title`) && (
            <h1>{t(`filter:${selectedFilter}Title`)}</h1>
          )}
          {!isUndefined(Component) && (
            <Component componentName={selectedFilter} className='filter' />
          )}
        </div>
      </StyledMain>
      <StyledActions>
        <StyledResetButton
          variant='outlined'
          color='primary'
          startIcon={<UiIcon icon='icon ri-arrow-go-back-line ' size={20} />}
          onClick={onReset}
        >
          {t('common:undo')}
        </StyledResetButton>
        <div className='end-actions'>
          <UiButton variant='outlined' color='primary' onClick={onClose}>
            {t('common:close')}
          </UiButton>
          <UiButton variant='contained' color='primary' onClick={onApply}>
            {t('filter:applyFilters')}
          </UiButton>
        </div>
      </StyledActions>
    </StyledUiDialog>
  );
}

AddFilterDialog.propTypes = {
  sliceModule: PropTypes.object,
  onApply: PropTypes.func,
  onClose: PropTypes.func,
  onReset: PropTypes.func,
  mapToComponent: PropTypes.object,
  allowedFilters: PropTypes.arrayOf(PropTypes.string),
};

export default AddFilterDialog;
